import React from "react";
import { Alert, Modal, Spin } from "@arco-design/web-react";
import { describeUsage, groupUsages } from "./fileUsage";

// Asks before deleting files. loadUsages(names), if given, resolves the forms
// and emails that show them and the signups that give them away, which are
// listed as a warning: those stop working once the file is deleted.
export default function DeleteFilesDialog({ count, names, loadUsages, render, onSave }) {
  const [open, setOpen] = React.useState(false);
  // null while loading; [] when nothing uses the files or the check failed.
  const [usages, setUsages] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
    setUsages(loadUsages ? null : []);
    if (loadUsages) {
      loadUsages(names || []).then(
        (list) => setUsages(Array.isArray(list) ? list : []),
        () => setUsages([])
      );
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    onSave && onSave();
    handleClose();
  };

  const groups = groupUsages(usages);
  const described = (usages || []).map(describeUsage);
  const anySent = described.some((d) => d.sent);
  const anyGiveaway = described.some((d) => d.giveaway);
  const anyImage = described.some((d) => !d.giveaway);

  return (
    <div>
      {render(handleClickOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        onOk={handleSave}
        title={`Delete File${count > 1 ? "s" : ""}`}
        okText={groups.length > 0 ? "Delete anyway" : "Delete"}
        okButtonProps={{ status: groups.length > 0 ? "danger" : undefined, disabled: usages === null }}
        cancelText="Cancel"
      >
        <p style={{ marginTop: 0 }}>Are you sure you want to delete {count} file{count > 1 && "s"}?</p>
        {usages === null && (
          <div><Spin size={14} /> Checking where {count > 1 ? "they're" : "it's"} used…</div>
        )}
        {groups.length > 0 && (
          <Alert
            type="warning"
            title="These are still in use"
            content={
              <div>
                <p style={{ margin: "4px 0" }}>
                  These stop working once {count > 1 ? "they're" : "it's"} deleted:
                </p>
                {groups.map((g) => (
                  <div key={g.fileName} style={{ marginBottom: 8 }}>
                    <strong>{g.fileName}</strong>
                    <ul style={{ margin: "2px 0", paddingLeft: 18 }}>
                      {g.usages.map((u) => {
                        const d = describeUsage(u);
                        return (
                          <li key={u.kind + u.id}>
                            {d.href ? <a href={d.href} target="_blank" rel="noopener noreferrer">{d.text}</a> : d.text}
                            {d.sent && " (already sent)"}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))}
                {anySent && (
                  <p style={{ margin: "4px 0" }}>
                    Emails already sent will show a broken image to people who open them later.
                  </p>
                )}
                {anyGiveaway && (
                  <p style={{ margin: "4px 0" }}>
                    Download links already sent for a giveaway stop working. Uploading a file with the same name brings them back.
                  </p>
                )}
                {anyImage && (
                  <p style={{ margin: "4px 0" }}>
                    Images in forms and emails don't come back if you upload a file with the same name later. You'd have to choose the image again in each one.
                  </p>
                )}
              </div>
            }
          />
        )}
      </Modal>
    </div>
  );
}
